
export const SET_CUSTOMER_DETAILS = "SET_CUSTOMER_DETAILS";
export const IMAGE_UPLOAD_REQUEST = "IMAGE_UPLOAD_REQUEST";
export const IMAGE_UPLOAD_SUCCESS = "IMAGE_UPLOAD_SUCCESS";
export const IMAGE_UPLOAD_FAILED = "IMAGE_UPLOAD_FAILED";


export const baseUrl = 'https://api.scholarrank.com' + '/file';
export const FILE_UPLOAD_URL = baseUrl + '/upload';
